import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadCommitteeMeeting: ICommitteeMeetingLoadActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEMEETING_LOAD,
            committeeId
        }
    },
    LoadCommitteeMeetingById: ICommitteeMeetingLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_COMMITTEEMEETING_LOAD_BY_ID,
            id
        }
    },
    LoadCommitteeMeetingByCommitteeId: ICommitteeMeetingLoadByCommitteeIdActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEMEETING_LOAD_BY_COMMITTEE_ID,
            committeeId
        }
    },
    LoadSuccess: ICommitteeMeetingLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETING_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ICommitteeMeetingLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETING_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveCommitteeMeeting: ICommitteeMeetingSaveActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEMEETING_SAVE,
            formData
        }
    },
    SaveSuccess: ICommitteeMeetingSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETING_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ICommitteeMeetingSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETING_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateCommitteeMeeting: ICommitteeMeetingCreateActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEMEETING_CREATE,
            committeeId
        }
    },
    CreateSuccess: ICommitteeMeetingCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_COMMITTEEMEETING_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ICommitteeMeetingCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETING_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateCommitteeMeeting: ICommitteeMeetingValidateActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEMEETING_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ICommitteeMeetingValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETING_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ICommitteeMeetingValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETING_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ICommitteeMeetingClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_COMMITTEEMEETING_CLEAR,
            propertiesToClear
        }
    },

    Filter: ICommitteeMeetingFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_COMMITTEEMEETING_FILTER,
            formFilter
        }
    };



export const
    ACTION_COMMITTEEMEETING_LOAD = "ACTION_COMMITTEEMEETING_LOAD",
    ACTION_COMMITTEEMEETING_LOAD_BY_ID = "ACTION_COMMITTEEMEETING_LOAD_BY_ID",
    ACTION_COMMITTEEMEETING_LOAD_BY_COMMITTEE_ID = "ACTION_COMMITTEEMEETING_LOAD_BY_COMMITTEE_ID",
    ACTION_COMMITTEEMEETING_LOAD_SUCCESS = "ACTION_COMMITTEEMEETING_LOAD_SUCCESS",
    ACTION_COMMITTEEMEETING_LOAD_FAILURE = "ACTION_COMMITTEEMEETING_LOAD_FAILURE",

    ACTION_COMMITTEEMEETING_SAVE = "ACTION_COMMITTEEMEETING_SAVE",
    ACTION_COMMITTEEMEETING_SAVE_SUCCESS = "ACTION_COMMITTEEMEETING_SAVE_SUCCESS",
    ACTION_COMMITTEEMEETING_SAVE_FAILURE = "ACTION_COMMITTEEMEETING_SAVE_FAILURE",

    ACTION_COMMITTEEMEETING_CREATE = "ACTION_COMMITTEEMEETING_CREATE",
    ACTION_COMMITTEEMEETING_CREATE_SUCCESS = "ACTION_COMMITTEEMEETING_CREATE_SUCCESS",
    ACTION_COMMITTEEMEETING_CREATE_FAILURE = "ACTION_COMMITTEEMEETING_CREATE_FAILURE",

    ACTION_COMMITTEEMEETING_VALIDATE = "ACTION_COMMITTEEMEETING_VALIDATE",
    ACTION_COMMITTEEMEETING_VALIDATE_SUCCESS = "ACTION_COMMITTEEMEETING_VALIDATE_SUCCESS",
    ACTION_COMMITTEEMEETING_VALIDATE_FAILURE = "ACTION_COMMITTEEMEETING_VALIDATE_FAILURE",

    ACTION_COMMITTEEMEETING_CLEAR = "ACTION_COMMITTEEMEETING_CLEAR",

    ACTION_COMMITTEEMEETING_FILTER = "ACTION_COMMITTEEMEETING_FILTER";

export interface ICommitteeMeetingLoadAction {
    type: "ACTION_COMMITTEEMEETING_LOAD";
    committeeId: number;
}

export interface ICommitteeMeetingLoadActionCreator {
    (committeeId: number): ICommitteeMeetingLoadAction;
}

export interface ICommitteeMeetingLoadSuccessAction {
    type: "ACTION_COMMITTEEMEETING_LOAD_SUCCESS";
    formData: Dtos.CommitteeMeeting | Dtos.CommitteeMeeting[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMeetingLoadSuccessActionCreator {
    (
        formData: Dtos.CommitteeMeeting | Dtos.CommitteeMeeting[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMeetingLoadSuccessAction;
}

export interface ICommitteeMeetingLoadFailureAction {
    type: "ACTION_COMMITTEEMEETING_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMeetingLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMeetingLoadFailureAction;
}

export interface ICommitteeMeetingLoadByIdAction {
    type: "ACTION_COMMITTEEMEETING_LOAD_BY_ID";
    id: number;
}

export interface ICommitteeMeetingLoadByIdActionCreator {
    (id: number): ICommitteeMeetingLoadByIdAction;
}

export interface ICommitteeMeetingLoadByCommitteeIdAction {
    type: "ACTION_COMMITTEEMEETING_LOAD_BY_COMMITTEE_ID";
    committeeId: number;
}

export interface ICommitteeMeetingLoadByCommitteeIdActionCreator {
    (committeeId: number): ICommitteeMeetingLoadByCommitteeIdAction;
}

export interface ICommitteeMeetingSaveAction {
    type: "ACTION_COMMITTEEMEETING_SAVE";
    formData: Dtos.CommitteeMeeting;

}

export interface ICommitteeMeetingSaveActionCreator {
    (
        formData: Dtos.CommitteeMeeting
    ): ICommitteeMeetingSaveAction;
}

export interface ICommitteeMeetingSaveSuccessAction {
    type: "ACTION_COMMITTEEMEETING_SAVE_SUCCESS";
    formData: Dtos.CommitteeMeeting;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMeetingSaveSuccessActionCreator {
    (
        formData: Dtos.CommitteeMeeting,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMeetingSaveSuccessAction;
}

export interface ICommitteeMeetingSaveFailureAction {
    type: "ACTION_COMMITTEEMEETING_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMeetingSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMeetingSaveFailureAction;
}

export interface ICommitteeMeetingCreateAction {
    type: "ACTION_COMMITTEEMEETING_CREATE",
    committeeId: number
}

export interface ICommitteeMeetingCreateActionCreator {
    (committeeId: number): ICommitteeMeetingCreateAction
}

export interface ICommitteeMeetingCreateSuccessAction {
    type: "ACTION_COMMITTEEMEETING_CREATE_SUCCESS";
    formData: Dtos.CommitteeMeeting;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ICommitteeMeetingCreateSuccessActionCreator {
    (
        formData: Dtos.CommitteeMeeting,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ICommitteeMeetingCreateSuccessAction;
}

export interface ICommitteeMeetingCreateFailureAction {
    type: "ACTION_COMMITTEEMEETING_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMeetingCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMeetingCreateFailureAction;
}

export interface ICommitteeMeetingValidateAction {
    type: "ACTION_COMMITTEEMEETING_VALIDATE";
    formData: Dtos.CommitteeMeeting;

}

export interface ICommitteeMeetingValidateActionCreator {
    (
        formData: Dtos.CommitteeMeeting
    ): ICommitteeMeetingValidateAction;
}

export interface ICommitteeMeetingValidateSuccessAction {
    type: "ACTION_COMMITTEEMEETING_VALIDATE_SUCCESS";
    formData: Dtos.CommitteeMeeting;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMeetingValidateSuccessActionCreator {
    (
        formData: Dtos.CommitteeMeeting,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMeetingValidateSuccessAction;
}

export interface ICommitteeMeetingValidateFailureAction {
    type: "ACTION_COMMITTEEMEETING_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMeetingValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMeetingValidateFailureAction;
}

export interface ICommitteeMeetingClearAction {
    type: "ACTION_COMMITTEEMEETING_CLEAR";
    propertiesToClear?: string[];
}

export interface ICommitteeMeetingClearActionCreator {
    (propertiesToClear?: string[]): ICommitteeMeetingClearAction;
}

export interface ICommitteeMeetingFilterActionCreator {
    (formFilter: IFormFilter): ICommitteeMeetingFilterAction;
}

export interface ICommitteeMeetingFilterAction {
    type: "ACTION_COMMITTEEMEETING_FILTER";
    formFilter: IFormFilter;
}


export type CommitteeMeetingAction =
    ICommitteeMeetingLoadAction |
    ICommitteeMeetingLoadByIdAction |
    ICommitteeMeetingLoadByCommitteeIdAction |
    ICommitteeMeetingLoadFailureAction |
    ICommitteeMeetingLoadSuccessAction |
    ICommitteeMeetingSaveAction |
    ICommitteeMeetingSaveSuccessAction |
    ICommitteeMeetingSaveFailureAction |
    ICommitteeMeetingCreateAction |
    ICommitteeMeetingCreateSuccessAction |
    ICommitteeMeetingCreateFailureAction |
    ICommitteeMeetingValidateAction |
    ICommitteeMeetingValidateSuccessAction |
    ICommitteeMeetingValidateFailureAction |
    ICommitteeMeetingClearAction | 
    ICommitteeMeetingFilterAction;
